"use client";
import PreviewCkeditor from "./PreviewCkeditor";

const ContentPostComponent = ({ data }: Readonly<{ data: string }>) => {
  return <PreviewCkeditor content={data} />;
};

export default ContentPostComponent;
